import React, { useState } from 'react';
import { Modal } from 'antd';
import PlanDetails from './planPricing/planDetails';
import { UR_Owner } from '../State';
import { checkAccess } from '../Auth';

const UpgradeToBusinessModal = ({ isOpen, onClose, onUpgrade, onViewPlanDetail, upgradeTo = 'business' }) => {
    const [isPlanDetailModalOpen, setIsPlanDetailModalOpen] = useState(false);

    // 根据upgradeTo参数获取相应的文案和配置
    const getModalConfig = () => {
        if (upgradeTo === 'individual') {
            return {
                title: 'Upgrade to Individual',
                subtitle: 'Access this feature and more by upgrading to the Individual Plan.',
                price: '$8',
                priceUnit: '/mo per user',
                features: [
                    'Everything in Explorer',
                    'Unlimited FNM / 1003 exports',
                    'Unlimited Strata AI',
                    'Whitelabeled personal website',
                    'OpenHouse Finder',
                    'Rate Marketplace'
                ]
            };
        } else {
            // 默认business plan
            return {
                title: 'Upgrade to Business',
                subtitle: 'Access this feature and more by upgrading to the Business Plan.',
                price: '$35',
                priceUnit: '/mo per company',
                features: [
                    'Everything in Individual Plan',
                    'Add team members',
                    'APIs & LOS/CRM integrations',
                    'Dedicated AE'
                ]
            };
        }
    };

    const modalConfig = getModalConfig();

    const svg_check = () => {
        return (
            <span style={{marginRight: 8, marginBottom: 4}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6529 6.34713C20.1157 6.80998 20.1157 7.56039 19.6529 8.02324L9.92593 17.7502L4.34713 12.1714C3.88429 11.7085 3.88429 10.9581 4.34713 10.4953C4.80998 10.0324 5.56039 10.0324 6.02324 10.4953L9.92593 14.398L17.9768 6.34713C18.4396 5.88429 19.19 5.88429 19.6529 6.34713Z" fill="#2E605A"/>
                </svg>
            </span>
        )
    };

    const handleUpgrade = () => {
        if (onUpgrade) {
            onUpgrade();
        } else {
            // 默认行为：跳转到定价页面
            sessionStorage.setItem('path', 'Pricing');
            window.open('/app/management', '_self');
        }
    };

    const handleViewPlanDetail = () => {
        // if (onViewPlanDetail) {
        //     onViewPlanDetail();
        // } else {
            // 默认行为：在当前页面打开计划详情弹窗
            setIsPlanDetailModalOpen(true);
        // }
    };

    return (
        <>
            <Modal
                width={600}
                className='upgrade-plan-modal'
                open={isOpen} 
                footer={null} 
                onCancel={onClose}
                style={{ zIndex: 9999999 }}
            >
                <div style={{ textAlign: 'left', padding: '31px 18px 16px 18px' }}>
                    <div className='upgrade-plan-modal-title'>
                        {modalConfig.title}
                    </div>
                    <div className='upgrade-plan-modal-subtitle'>
                        {modalConfig.subtitle}
                    </div>
                    
                    <div>
                        <div className='upgrade-plan-modal-detail-price'>
                            {modalConfig.price} <span className='upgrade-plan-modal-detail-price-text'>{modalConfig.priceUnit}</span>
                        </div>
                        <div style={{ fontSize: 16, fontWeight: 500, color: '#222', marginTop: 18 }}>
                            {modalConfig.features.map((feature, index) => (
                                <div key={index} className='upgrade-plan-modal-detail-item'>
                                    {svg_check()}
                                    <span className='upgrade-plan-modal-detail-text'>{feature}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {checkAccess([UR_Owner]) && <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginTop: 83 }}>
                        <div 
                            className='upgrade-plan-modal-detail-btn'
                            onClick={handleViewPlanDetail}
                        >
                            View plan detail
                        </div>
                        <div 
                            className='upgrade-plan-modal-upgrade-btn'
                            onClick={handleUpgrade}
                        >
                            Upgrade now
                        </div>
                    </div>}
                    {!checkAccess([UR_Owner]) && <div style={{ textAlign: 'left', marginTop: 24, fontSize: 20, fontWeight: 500, color: '#808080', lineHeight: '24px' }}>
                        Please contact your account admin to upgrade.
                    </div>}
                </div>
            </Modal>

            {/* 计划详情弹窗 - 使用新的PlanDetails组件 */}
            <Modal
                title=""
                open={isPlanDetailModalOpen}
                onCancel={() => setIsPlanDetailModalOpen(false)}
                footer={null}
                width={1000}
                centered
                style={{ zIndex: 9999999 }}
            >
                <PlanDetails />
            </Modal>
        </>
    );
};

export default UpgradeToBusinessModal; 
